import React from 'react'

const Homehrhelpdesk = () => {
  return (
    <section id="features-details" className="features-details section">
      <div className="container">
        <div className="row gy-4 justify-content-between features-item">
          <div className="col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay={100}>
            <img src="https://sigohrmlpadmin.loopring.in/front/images/homehrhelpdeskmanagements/13890.png" className="img-fluid" alt />
          </div>
          <div className="col-lg-5 d-flex align-items-center">
            <div className="content">
              <h3>HR HELP DESK</h3>
              <p>
              </p><p>Provide incomparable support to your employees, wherever they are, any time they need you with an efficient, automated, and advanced helpdesk system.Employees can get assistance or ask questions about human resources rules, practises, and benefits at the HR help desk, a single point of contact.&nbsp;</p>
              <p />
              <ul>
                <li><i className="bi bi-easel flex-shrink-0" /> Improved analytics and reporting</li>
                <li><i className="bi bi-patch-check flex-shrink-0" /> Information and support</li>
                <li><i className="bi bi-brightness-high flex-shrink-0" /> HR policies and practises</li>
                <li><i className="bi bi-brightness-high flex-shrink-0" /> Issue resolution</li>
              </ul>
              <p />
              <a href="#" className="btn more-btn">Learn More</a>
            </div>
          </div>
        </div>{/* Features Item */}
      </div>
    </section>

  )
}

export default Homehrhelpdesk
